import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminProductHubs from "@/pages/admin/AdminProductHubs";

export const Route = createFileRoute("/admin/products/")({
  component: () => (
    <ProtectedRoute>
      <AdminProductHubs />
    </ProtectedRoute>
  ),
});
